import PayoneerPending from './payoneer-pending';

export default PayoneerPending;
